const host = {
  chaturl: process.env.REACT_APP_CHAT_URL,
  textToSpeechApikey: process.env.REACT_APP_TEXT_TO_SPEECH_APIKEY,
  azureClientId: process.env.REACT_APP_AZURE_CLIENT_ID,
  azureTenantId: process.env.REACT_APP_AZURE_TENANT_ID,
  azureRedirectUri: process.env.REACT_APP_AZURE_REDIRECT_URI,
  brainurl: process.env.REACT_APP_BRAIN_URL,
  adminurl: process.env.REACT_APP_ADMIN_URL,
};
export default host;
